export default __webpack_public_path__ + "static/media/light.177b1d4b.png";